import { useKeycloakInstance, useProfile } from '@dhl/keycloak'
import { config } from '~/config'
import type { RoleName } from '~/modules/adminusers/model/RoleName'
import { getEnv } from '~/getEnv'
import { e2eUser } from '~/common/e2eUser'

export const useCurrentUser = () => {
  const isE2eTest = getEnv() === 'e2e'
  const { data: profile } = useProfile()

  const { resourceAccess } = useKeycloakInstance()
  const keycloakRoles = resourceAccess?.[config.authClient]
  const userRoles = isE2eTest ? e2eUser.roles : (keycloakRoles?.roles ?? [])

  const hasRole = (role: RoleName) => userRoles.includes(role)

  return {
    id: isE2eTest ? e2eUser.id : profile?.id,
    roles: userRoles,
    hasRole,
    isCCC: hasRole('CCC'),
  }
}
